import { connect } from 'react-redux';
import { showGtiBeginModal } from '../../../../data/service/gti/actions';
import { config } from '../../../../definitions/TimelineItems';
import { getDepartmentDisplay } from '../../../../utils/TimelineUtils';
import TimelineItem from '../TimelineItem';
import { OTLink } from '../../../../components/tag/OTLink';
import { FormattedMessage } from 'react-intl';
import { TYPE_DEFAULT } from '../../../../definitions/TimelineItems';
import { getGtiAppointmentStatus } from '../../../../data/util';
import classnames from 'classnames';
import OTIcon from '../../../../components/tag/OTIcon';
import { selectIsHpa } from '../../../../data/hpa/selectors';
import CommonInstructions from '../CommonInstructions';
import { notEmpty } from '../../../../utils/Functions';
import QLink from '../QLink';
import React from 'react';

let { id: module_id } = module;

const GTITimelineItem = ({
  past,
  data,
  showGtiBeginModal,
  instructions,
  isHpa,
  qIsFetching,
  visibleQuestionnaires,
  linkValue,
  hasLink,
}) => {
  let linkToGti = null;
  let status = getGtiAppointmentStatus(data);

  const hasLinkValue = hasLink(linkValue);

  if (status != null && !isHpa) {
    linkToGti = (
      <div className="row-fluid">
        <div className="span12">
          <OTIcon
            className={'card-icon'}
            config={{ type: 'custom', name: 'kyselyt', color: 'lightblue' }}
          />
          <button
            disabled={status === 'INACTIVE'}
            onClick={showGtiBeginModal}
            className={classnames(
              'card-link',
              'gti-link',
              status === 'INACTIVE' && 'gti-link--inactive'
            )}
          >
            <FormattedMessage id={'gti.timelineitem.title'} />
          </button>
          <br />
          <span className={'gti-link-description'}>
            <OTIcon
              config={{ type: 'custom', name: 'palaute', color: 'darkblue' }}
              style={{
                height: '13px',
                width: '15px',
                marginRight: '5px',
                position: 'absolute',
                left: '21px',
                top: '3px',
              }}
            />
            <FormattedMessage id={'gti.link.message'} />
          </span>
        </div>
      </div>
    );
  }

  return (
    <TimelineItem
      {...config[TYPE_DEFAULT]}
      past={past}
      data={data}
      date={data.date}
      contentDescription={
        <>
          <p>
            <span style={{ textDecoration: 'underline' }}>
              {getDepartmentDisplay(data.department)}
            </span>
          </p>
          <p>
            {(qIsFetching || notEmpty(visibleQuestionnaires)) &&
              visibleQuestionnaires.map((q) => (
                <QLink
                  key={q.id}
                  qIsFetching={qIsFetching}
                  data={data}
                  questionnaire={q}
                />
              ))}
          </p>
        </>
      }
      contentExpanded={
        <>
          {
            <>
              {hasLinkValue && (
                <div className="span6">
                  <i className="card-icon icon-info" />{' '}
                  <OTLink
                    target="_blank"
                    onClick={(e) => e.stopPropagation()}
                    link={linkValue}
                    isExternal
                    className="card-link"
                  >
                    <FormattedMessage id={`${module_id}.GTI.info`} />
                  </OTLink>
                </div>
              )}
              {linkToGti}
            </>
          }
          {instructions && (
            <div className={'instructions'}>
              <h3>
                <FormattedMessage id={'visiting.instructions'} />
              </h3>
              <CommonInstructions instructions={instructions} />
            </div>
          )}
        </>
      }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    isHpa: selectIsHpa(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showGtiBeginModal: () => dispatch(showGtiBeginModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GTITimelineItem);
